import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ShellPagesRoutingModule } from './shell-pages-routing.module';
import { ShellPagesComponent } from './shell-pages.component';
import { SharedModule } from 'primeng/api';
import { CoreModule } from '../../../core/core.module';
import { FooterModule } from '@modules/commom/footer/footer.module';
import { HeaderModule } from '@modules/commom/header/header.module';
import { GenesysChatComponent } from '@modules/commom/genesys-chat/genesys-chat.component';
import { LoaderSpinnerComponent } from '@shared/components/loader-spinner/loader-spinner.component';

@NgModule({
  declarations: [ShellPagesComponent],
  imports: [
    CommonModule,
    RouterModule,
    ShellPagesRoutingModule,
    CoreModule,
    SharedModule,
    HeaderModule,
    FooterModule,
    LoaderSpinnerComponent,
    GenesysChatComponent
  ]
})
export class ShellPagesModule { }
